import PartnerFragment from '@/lib/fragments/partner'
import SectionPaddingFragment from '@/lib/fragments/section-padding'
import { graphql } from '@/lib/query'

const SectionPartnersFragment = graphql(
  /* GraphQL */ `
    fragment SectionPartnersFragment on SectionPartnerRecord @_unmask {
      _modelApiKey
      __typename
      hide
      bg
      sectionPadding {
        ...SectionPaddingFragment
      }
      title
      description
      partners {
        ...PartnerFragment
      }
    }
  `,
  [SectionPaddingFragment, PartnerFragment]
)

export default SectionPartnersFragment
